export default "__VITE_ASSET__dbe94644__"